import React, { useMemo, useState } from 'react';
import { Form, Select, DatePicker, Button, Input, Layout, Menu, Card } from 'antd';
import 'antd/dist/antd.css';
import './EproAnnounceScreen.css';
import { Content, Footer } from 'antd/lib/layout/layout';
import { announcementlatest, announcementtype } from '../../Services/e-pro/EproAnnounceService';
import { CheckCircleOutlined } from '@ant-design/icons';
import { FileTextOutlined } from '@ant-design/icons';

const { Option } = Select;
const { RangePicker } = DatePicker;

export const EproAnnounce = () => {
    let [laster, setlaster] = useState<announcementtype[]>([])
    const retrieve = async () => {
        let te = await announcementlatest()
        setlaster(te)
    }

    useMemo(() => {
        retrieve();
    }, [])
    return (
        <Layout className="containers">

            <Content className="contents">
                <div className="search-section-container" >
                    <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className='search-section'>
                            <div >
                                {/* First Button */}
                                <Button size='large' style={{ width: "300px", height: "100px", display: 'flex', alignItems: 'center', fontSize: '24px', padding: '10px 20px', borderRadius: "15px" }}>
                                    <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', fontSize: '40px', fontWeight: 'bold' }} >รอดำเนินการ</span>
                                    <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', fontSize: '50px', fontWeight: 'bold' }}>10</span>
                                    <span style={{ marginLeft: '10px', fontSize: '50px' }}><CheckCircleOutlined rev={undefined} /></span>
                                </Button>
                                {/* Second Button */}
                                <Button style={{ width: "300px", height: "100px", display: 'flex', alignItems: 'center', fontSize: '24px', padding: '10px 20px', marginTop: '10px', borderRadius: "15px" }}>
                                    <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', fontSize: '40px', fontWeight: 'bold' }}>ฉบับร่าง</span>
                                    <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', fontSize: '50px', fontWeight: 'bold' }}>10</span>
                                    <span style={{ marginLeft: '10px', fontSize: '50px' }}><FileTextOutlined rev={undefined} /></span>
                                </Button>
                            </div>
                            <div className='search-sections'>
                                <div className='search'>
                                    <h2 style={{ fontWeight: "bolder", fontSize: "40px" }}>ค้นหาประกาศจัดซื้อจัดจ้าง</h2>
                                    <Form layout="vertical">
                                        <Form.Item label={<span className="custom-label">ประเภทของประกาศ</span>}>
                                            <Select placeholder="เลือกประเภทของประกาศ" style={{ fontSize: "20px" }}>
                                                <Option value="1">Option 1</Option>
                                            </Select>
                                        </Form.Item>
                                        <div className='search-group'>
                                            <Form.Item label={<span className="custom-label">หน่วยงาน</span>} style={{ width: "60%" }}>
                                                <Select placeholder="ค้นหาชื่อหน่วยงาน" style={{ fontSize: "20px" }}></Select>
                                            </Form.Item>
                                            <Form.Item label={<span className="custom-label">วันที่</span>} style={{ width: "40%" }}>
                                                <RangePicker className="custom-range-picker" />
                                            </Form.Item>
                                        </div>
                                        <Button className="search-button">
                                            ค้นหาขั้นสูง
                                        </Button>
                                    </Form>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </Content>
        </Layout>
    );
};
